import React from "react";
import { connect } from "react-redux";
import { postClientUserDetails, getClientManagementList ,putClientUserDetails } from "../Actions/ClientManagementAPI";
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from 'react-confirm-alert';
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import swal from "sweetalert";
// const Clientlist = {
//   companyName: "",
//   email: "",
//   phone: "",
//   address: "",
//   createdBy: "",
// }
let user = JSON.parse(localStorage.getItem("currentUser"));
class ClientManagementAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ClientInfo: {
        companyName: "",
        email: "",
        phone: "",
        address: "",
        createdBy: "",
        isTeFromApplicable: false
      },
      FleetManager: {
        clientId: 0,
      },
      TechSuperintendent: {
        clientId: 0,
        createdBy: ""
      },
      TechExecutive: {
        clientId: 0,
        createdBy: ""
      },
      owner: false,
      management: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
  }
  componentDidMount() {
    const{dispatch}=this.props;
    this.props.dispatch({ type: 'SubBannerTitle', data: "Client Management" });
      let url = `${API.GetClientUserArray}`;
          axios.get(url)
              .then((response) => {
                  if(response.status===200){
                      dispatch({
                          type: "getFleetManagerArrayListSuccess",
                          data: response.data,

                      })
                  }
                   })
              .catch((error) => {
                  dispatch({
                      type: "getFleetManagerArrayListFailure",
                      error: "ERROR"
                  })
              })
      }

  


  static getDerivedStateFromProps(nextProps, prevState) {
    const { fleetManagerlist, TechExecutivelist, TechSuperintendentlist } = nextProps;
    if (fleetManagerlist) {
      prevState.FleetManager = fleetManagerlist;
    }
    if (TechSuperintendentlist) {
      prevState.TechSuperintendent = TechSuperintendentlist;
    }
    if (TechExecutivelist) {
      prevState.TechExecutive = TechExecutivelist;
    }
    // if (clientId && clientId !== "") {
    //   prevState.FleetManager.clientId = clientId;
    //   prevState.TechSuperintendent.clientId = clientId;
    //   prevState.TechExecutive.clientId = clientId;
    //   let users = [prevState.FleetManager, prevState.TechSuperintendent, prevState.TechExecutive];
    //   console.log("users", users);
    // }
  }

  SubmitData() {
    const { dispatch, fleetManagerlist, TechExecutivelist, TechSuperintendentlist } = this.props;
    let searchData = {
      Name: '',
      PageNumber: 1,
      PageSize: 25
    }

    if (this.state.ClientInfo.email !== "" && this.state.ClientInfo.companyName !== "") {
      let url2 = `${API.userExist}?Mail=${this.state.ClientInfo.email}&Id=${0}`
      axios.get(url2, {
        headers: {
          key: user.accessToken
        }
      })
        .then((response) => {
          if (response.data === true) {
            let url = `${API.postClient}`;
            axios.post(url, this.state.ClientInfo, {
              headers: {
                key: user.accessToken,
              }
            })
              .then((response) => {
                let finalArray=[];
                let FinalArray1=[];
                let FinalArray2=[];
                if ( fleetManagerlist &&  fleetManagerlist.length > 0) {
                let user = fleetManagerlist?.map(u1 => {
                    finalArray.push(u1.clientUserId)
                   })
                  }
                  if ( TechSuperintendentlist &&  TechSuperintendentlist.length > 0) {
                    let user = TechSuperintendentlist?.map(u2 => {
                        FinalArray1.push(u2.clientUserId)
                       })
                      }
                      if ( TechExecutivelist && TechExecutivelist.length > 0) {
                        let user = TechExecutivelist?.map(u3 => {
                            FinalArray2.push(u3.clientUserId)
                           })
                          }
              
                        
                 let user1 = 
                  [{
                    clientUserIds: finalArray.length>0?finalArray.toString():"",
                    clientId: response.data,
                    isDeleted: false,
                    role: "fleetmanager",
                    modifiedBy: user.email
                  }]
                 let user2 = 
                  [{
                    clientUserIds: FinalArray1.length>0?FinalArray1.toString():"",
                    clientId: response.data,
                    isDeleted: false,
                    role: "superintendent",
                    modifiedBy: user.email
                  }]
                  let user3=[{
                    clientUserIds: FinalArray2.length>0?FinalArray2.toString():"",
                    clientId: response.data,
                    isDeleted: false,
                    role: "technicalexecutive",
                    modifiedBy: user.email
                  }]
                  let clientUsers = [...user1,...user2,...user3];
                // console.log("clientUsers", clientUsers);
                if (finalArray.length != 0 || FinalArray1.length !==0 || FinalArray2.length !==0) {
                  dispatch(putClientUserDetails(clientUsers))
                 
                }
                toast.success("Added Successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                dispatch({ type: "GetTechExecutivelist", data: null });
                dispatch({ type: "GetTechSuperintendentlist", data: null });
                dispatch({ type: "GetFleetManagerlist", data: null });
                dispatch(getClientManagementList(searchData));
                this.props.history.push("/Home/Management/Client");
               dispatch({
                  type: "postClientDetailsSuccess",
                  data: response.data,
                })
              })
              .catch((error) => {
                dispatch({
                  type: "postClientDetailsFailure",
                  error: "ERROR"
                })
              })
          } else if (response.data === false) {
            swal('Error!', 'User already exist. Please change the email', 'warning');
            this.state.ClientInfo.email = "";
            this.setState({});
          }
          dispatch({
            type: 'getUserExistListSuccess',
            data: response.data
          })
        })
        .catch((error) => {
          dispatch({
            type: 'getUserExistListFailure',
            data: "error"
          })
        })
    } else if (this.state.ClientInfo.companyName == "" && this.state.ClientInfo.email == "") {
      swal('Error!', 'Name and Email is mandatory', 'warning');
    } else if (this.state.ClientInfo.companyName == "") {
      swal('Error!', 'Name is mandatory', 'warning');
    } else {
      swal('Error!', 'Email is mandatory', 'warning');
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.ClientInfo[nodeName] = e.target.value;
    this.setState({});
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.state.ClientInfo.isTeFromApplicable = true
      this.setState({});
    } else {
      this.state.ClientInfo.isTeFromApplicable = false
      this.setState({});
    }
  }

  render() {
    const { showSidePane, fleetManagerlist, TechSuperintendentlist, TechExecutivelist } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="row search-filter-box">
                <div className="col-lg-12">
                  <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                      <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Basic Information</h5>
                    </div>
                  </div>
                  <div className="row search-filter-box pb-4">
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="companyName"
                        placeholder="Name"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.companyName}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.email}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Phone </label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone"
                        placeholder="Phone "
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.phone}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Address</label>
                      <textarea
                        className="form-control"
                        // type="textarea"
                        name="address"
                        placeholder="Address"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.address}
                      ></textarea>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label" >TE Forms Applicable</label><br></br>
                      <input type="checkbox" name="isTeFromApplicable" checked={this.state.ClientInfo.isTeFromApplicable} onChange={(e) => this.handleCheckBoxChange(e)}></input>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-12">
                      <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                          <h5 className="card-title m-2" style={{ color: "092a51" }}>Fleet Managers</h5>
                          <div className="m-1 flex" onClick={() => this.showFleetManagersSidePane()}>
                            <AddIcon />
                          </div>
                        </div>
                      </div>
                      <div className="search-filter-box pt-4">
                        {fleetManagerlist ? this.renderFleetManagerCard() : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                          <h5 className="card-title m-2" style={{ color: "092a51" }}>Technical Superintendents </h5>
                          <div className="m-1 flex" onClick={() => this.showTechSuperintendentsSidePane()}>
                            <AddIcon />
                          </div>
                        </div>
                      </div>
                      <div className="search-filter-box pt-4">
                        {TechSuperintendentlist ? this.renderTechSuperintendentCard() : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="flex card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                          <h5 className="card-title m-2" style={{ color: "092a51" }}>Technical Executive  </h5>
                          <div className="m-1 flex" onClick={() => this.showTechExecutiveSidePane()}>
                            <AddIcon />
                          </div>
                        </div>
                      </div>
                      <div className="search-filter-box pt-4">
                        {TechExecutivelist ? this.renderTechExecutiveCard() : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 py-2">
                      <div className="mb-1 search-btn-col" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit" onClick={() => this.SubmitData()}>Submit
                      </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button" onClick={() => this.moveClientList()}> {" "} Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderFleetManagerCard = () => {
    const { showSidePane, fleetManagerlist } = this.props;
    return (
      <>
        {fleetManagerlist.length && fleetManagerlist? fleetManagerlist.map((item) =>{ 
          return(
            <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.name} </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-1 col-2 col-m-auto">
                    <div className={showSidePane ? "text-center" : "text-center"}>
                    <i className="fa fa-trash fa-2x m-1" onClick={() => this.DeletePopup(item,"fleetManager")}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )
       }):
       <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                <div class="container">
                    <h6 className="resource-list-title no-item-card">
                        No Item to Display 
                </h6>
                </div>
            </div>
              }
      </>
    )
  }
  renderTechSuperintendentCard = () => {
    const { showSidePane, TechSuperintendentlist } = this.props;
    return (
      <>
        {TechSuperintendentlist && TechSuperintendentlist.length ?TechSuperintendentlist.map((item) => {
          return(
          <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.name}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-1 col-2 col-m-auto">
                    <div className={showSidePane ? "text-center" : "text-center"}>
                    <i className="fa fa-trash fa-2x m-1" onClick={() => this.DeletePopup(item,"TechSuperintendent")}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }):
        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
        <div class="container">
            <h6 className="resource-list-title no-item-card">
                No Item to Display 
        </h6>
        </div>
    </div>}
      </>
    )
  }
  renderTechExecutiveCard = () => {
    const { showSidePane, TechExecutivelist } = this.props;
    return (
      <>
        {TechExecutivelist && TechExecutivelist.length ?TechExecutivelist.map((item) => {
          return(
          <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.name}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-1 col-2 col-m-auto">
                    <div className={showSidePane ? "text-center" : "text-center"}>
                    <i className="fa fa-trash fa-2x m-1" onClick={() => this.DeletePopup(item,"TechExecutive")}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }):  <div className="card" style={{ overflow: "hidden", position: "relative" }}>
        <div class="container">
            <h6 className="resource-list-title no-item-card">
                No Item to Display 
        </h6>
        </div>
    </div>}
      </>
    )
  }
  EditEquipment(type, item) {
    this.props.dispatch({ type: "EditUser", data: true });
    if (type === "FleetManager") {
      this.props.dispatch({ type: "GetFleetManagerDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push("/Home/Management/ClientAdd/FleetManager");
    }
    else if (type === "TechSuperintendent") {
      this.props.dispatch({ type: "GetTechSuperintendentDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push("/Home/Management/ClientAdd/TechSuperintendent");
    }
    else if (type === "TechExecutive") {
      this.props.dispatch({ type: "GetTechExecutiveDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push("/Home/Management/ClientAdd/TechExecutive");
    }
  }

  moveClientList = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "GetTechExecutivelist", data: null });
    this.props.dispatch({ type: "GetTechSuperintendentlist", data: null });
    this.props.dispatch({ type: "GetFleetManagerlist", data: null });
    this.props.history.push("/Home/Management/Client");
  };

  showFleetManagersSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    // this.props.dispatch({ type: "GetFleetManagerlist", data: true });
    this.props.history.push("/Home/Management/ClientAdd/FleetManager");

  }

  showTechSuperintendentsSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    // this.props.dispatch({ type: "GetTechSuperintendentlist", data: null });
    this.props.history.push("/Home/Management/ClientAdd/TechSuperintendent");
  }
  DeletePopup(item,type) {
    confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    this.DeleteUser(item,type)
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }
  DeleteUser(item,type) {
    const { dispatch ,fleetManagerlist} = this.props;
    if(type==="fleetManager"){
      let clientuserArray = [];
      clientuserArray = this.props.fleetManagerlist.filter(x => x.clientUserId !== item.clientUserId);
      console.log(clientuserArray)
      dispatch({ type: "GetFleetManagerlist", data: clientuserArray });
    }else if(type==="TechSuperintendent"){
      let clientuserArray1 = [];
      clientuserArray1 = this.props.TechSuperintendentlist.filter(x => x.clientUserId !== item.clientUserId);
      console.log(clientuserArray1)
      dispatch({ type: "GetTechSuperintendentlist", data: clientuserArray1 });
    }else if(type==="TechExecutive"){
      let clientuserArray2 = [];
      clientuserArray2 = this.props.TechExecutivelist.filter(x => x.clientUserId !== item.clientUserId);
      console.log(clientuserArray2)
      dispatch({ type: "GetTechExecutivelist", data: clientuserArray2 });
    }
   

  }

  showTechExecutiveSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    // this.props.dispatch({ type: "GetTechExecutivelist", data: null });
    this.props.history.push("/Home/Management/ClientAdd/TechExecutive");
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    fleetManagerlist: state.MasterScreenReducer.fleetManagerlist || [],
    TechSuperintendentlist: state.MasterScreenReducer.TechSuperintendentlist || [],
    TechExecutivelist: state.MasterScreenReducer.TechExecutivelist || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientManagementAdd);
